const es = {
  metaTitle: "FearGreed — Botón de Sentimiento Crypto",
  metaDescription: "El Crypto Fear & Greed Index como un botón táctil. Actualizaciones programadas desde alternative.me. Sin cuentas, sin rastreo.",

  navAbout: "Docs",
  footerPrivacy: "Privacidad",
  footerSupport: "Soporte",
  footerAbout: "Docs",
  footerDataSource: "Datos: alternative.me · No es asesoramiento financiero",

  loading: "Cargando…",
  unableToLoad: "No se pudo cargar el índice",
  somethingWentWrong: "Algo salió mal.",
  tryAgain: "Reintentar",
  lastUpdated: "Actualizado {time}",
  updating: "Actualizando…",
  buttonUpdated: "Actualizado ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Fuente: alternative.me",
  ariaButton: "{value} {bucket} — Índice Fear and Greed. Toca para un insight.",

  ritualDisclaimer: "No es asesoramiento financiero",

  infoTitle: "Índice Fear & Greed",
  infoDescription: "Sentimiento del mercado crypto (0–100). Volatilidad, momentum, redes sociales, encuestas. Fuente: alternative.me. No es asesoramiento financiero.",
  infoAttribution: "Datos de alternative.me Crypto Fear & Greed Index.",
  info7d: "Tendencia 7 días",
  info30d: "Tendencia 30 días",
  infoNextUpdate: "Próxima actualización",
  infoInterpretTitle: "Cómo interpretar",
  infoInterpretExtremeFear: "0–24: Miedo Extremo. Históricamente ha precedido algunas recuperaciones.",
  infoInterpretExtremeGreed: "75–100: Codicia Extrema. Históricamente ha precedido algunas correcciones.",
  infoDisclaimer: "Solo indicador de sentimiento. Patrones pasados no predicen resultados futuros. Investiga por tu cuenta.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulso",
  infoDocsLink: "Docs completos y referencia API",

  backToButton: "Volver",

  aboutTitle: "Docs",
  aboutWhatTitle: "¿Qué es FearGreed?",
  aboutWhat: "Muestra el Crypto Fear & Greed Index — puntaje diario de sentimiento (0–100) calculado por alternative.me a partir de volatilidad, momentum, redes sociales, encuestas, dominancia y tendencias. Una señal. Sin ruido.",
  aboutWhyTitle: "¿Por qué FearGreed?",
  aboutWhyIntro: "El índice en bruto es un número. FearGreed lo convierte en producto.",
  aboutWhy1Title: "UX ritualizada",
  aboutWhy1: "Un botón táctil. Sin gráficos, sin ruido, sin dashboards. Toca, lee, sigue.",
  aboutWhy2Title: "Sincronización programada",
  aboutWhy2: "Revisa nuevos datos mediante ventanas cron programadas, alineadas con el ciclo de actualización diario de la fuente.",
  aboutWhy3Title: "Analíticas derivadas",
  aboutWhy3: "Delta, promedios móviles, pendiente, duración de régimen, etiquetas de vigilancia — calculados desde los datos brutos, no disponibles en la fuente.",
  aboutWhy4Title: "Pulso en lenguaje natural",
  aboutWhy4: "Frase de insight diaria generada por IA. Contextual, no genérica.",
  aboutWhy5Title: "Market tape",
  aboutWhy5: "Cambios 24h de BTC/ETH, market cap, dominancia, volumen y etiqueta de presión. Actualizado cada 4 horas.",
  aboutWhy6Title: "Para agentes",
  aboutWhy6: "Endpoints JSON estructurados, llms.txt, especificación OpenAPI y badge SVG. Diseñado para consumo programático.",
  aboutSourceTitle: "Fuente de datos",
  aboutSource: "Datos de alternative.me. La fuente se actualiza normalmente una vez al día alrededor de las 00:00 UTC. FearGreed verifica nuevos datos mediante ventanas cron programadas alineadas con este horario.",
  aboutApiTitle: "API",
  aboutApiDescription: "Endpoints públicos. CORS habilitado. JSON salvo indicación. Sin autenticación.",
  aboutApiLatest: "Último valor con analíticas derivadas: delta, promedios, distancia al neutral.",
  aboutApiHistory: "Últimos 30 valores diarios con bucket y color.",
  aboutApiSummary: "Resumen en texto plano. Útil para LLMs y agentes.",
  aboutApiBadge: "Badge SVG. Para READMEs o dashboards.",
  aboutApiContext: "Contexto diario generado por IA con tendencia y todas las analíticas derivadas. Caché 1h.",
  aboutApiPulse: "Analíticas estructuradas: régimen, señal, pendiente, promedios. Sin IA. Caché 15min.",
  aboutApiTape: "Cambios 24h BTC/ETH, capitalización, dominancia, volumen y etiqueta de presión. Caché 30min.",
  aboutBadgeTitle: "Badge / Embed estático",
  aboutBadgeDescription: "Inserta el índice actual como badge SVG:",
  aboutEmbedTitle: "Embed interactivo",
  aboutEmbedDescription: "Inserta el botón interactivo completo en cualquier página vía iframe. La misma experiencia táctil, sin chrome, solo datos en caché.",
  aboutCurlTitle: "Ejemplo de petición",
  aboutJsonExample: "Ejemplo de respuesta (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Resumen del proyecto legible por máquinas para agentes LLM y crawlers.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Especificación API completa en formato OpenAPI 3.0.",
  aboutDisclaimerTitle: "Aviso legal",
  aboutDisclaimer: "Solo utilidad de sentimiento. No predice movimientos de precio. No es asesoramiento financiero. Investiga por tu cuenta.",
  aboutNonAffiliation: "FearGreed es una interfaz independiente. No está afiliado ni respaldado por alternative.me.",
  staleIndicator: "Sin conexión · datos en caché",
  infoButton: "Más información",
  languageSelector: "Idioma",
  themeToggle: "Cambiar tema",

  privacyTitle: "Política de privacidad",
  privacyEffectiveDate: "Fecha de vigencia: 8 de marzo de 2026",
  privacySummaryTitle: "Resumen",
  privacySummary: "FearGreed no requiere login, no crea cuentas y no recopila datos personales.",
  privacyDataTitle: "Datos recopilados",
  privacyData: "Ninguno. Sin registros, sin cookies de rastreo, sin perfiles analíticos.",
  privacyTechTitle: "Datos técnicos",
  privacyTech: "La infraestructura puede registrar IPs y timestamps para fiabilidad. No vinculados a usuarios individuales.",
  privacyThirdPartyTitle: "Servicios de terceros",
  privacyThirdParty: "FearGreed obtiene datos de la API alternative.me. Consulta su política de privacidad.",
  privacyAdsTitle: "Publicidad",
  privacyAds: "FearGreed no muestra publicidad.",
  privacyChangesTitle: "Cambios",
  privacyChanges: "Actualizaciones se publicarán con fecha revisada.",
  privacyContactTitle: "Contacto",
  privacyContact: "¿Preguntas? Contáctanos en",

  supportTitle: "Soporte",
  supportDescription: "Para preguntas o problemas, contáctanos en:",

  bucketExtremeFear: "Miedo Extremo",
  bucketFear: "Miedo",
  bucketNeutral: "Neutral",
  bucketGreed: "Codicia",
  bucketExtremeGreed: "Codicia Extrema",

  pulseLabel: "Pulso:",
  regimeSuffix: "régimen {days}d",
  watchFearDeepening: "Miedo Profundizando",
  watchFearStabilizing: "Miedo Estabilizando",
  watchNeutralCompression: "Compresión Neutral",
  watchGreedAccelerating: "Codicia Acelerando",
  watchGreedOverheating: "Codicia Sobrecalentando",
  watchPossibleReversal: "Posible Reversión",
  watchTrendPersistence: "Tendencia Persistente",
  watchRecoveryBuilding: "Recuperación en Construcción",

  infoRegimePulse: "Régimen y Pulso",
  infoMarketTape: "Cinta de Mercado",
  infoPressure: "Presión",

  updateAvailable: "Actualización disponible",

  aboutViewLlmsTxt: "Ver llms.txt",
  aboutViewOpenapi: "Ver openapi.json",

  // Market pressure labels
  pressureBroadSellOff: "Venta masiva",
  pressureUnderPressure: "Bajo presión",
  pressureBroadRally: "Rally generalizado",
  pressureRiskAppetite: "Apetito de riesgo mejorando",
  pressureFlat: "Mercado plano",
  pressureMixed: "Señales mixtas",

  notFoundTitle: "Página no encontrada",
  notFoundBack: "Volver al inicio",

  hintTap: "púlsame",
} as const;

export default es;
